module.exports = __webpack_public_path__ + "static/media/image-upload.8bbc64b4.svg";